var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-popup',{attrs:{"position":"bottom"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('van-picker',{attrs:{"columns":_vm.cols,"show-toolbar":"","item-height":_vm.itemHeight,"visible-item-count":_vm.visibleItemCount},on:{"confirm":_vm.onConfirm,"cancel":_vm.onCancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }